<template>
    <div id="VaultApplyBox" class="thousand_layout">

        <div class="right_box">
            <div class="flex_layout_between">
                <h3 v-if="['add', 'edit'].includes(showType)">{{ $t('vault.VaultSubmission') }}</h3>
                <h3 v-if="['view'].includes(showType)">{{$t('vault.VaultSubmissionDetails')}}</h3>
                
            </div>


            <!-- @* #region 申请入库Form *@ -->
            <div :class="['apply-form-box']" v-show="['add', 'edit'].includes(showType)">
                <!-- @*第一步 填写卡片信息*@ -->
                <!-- <el-steps :active="step1" finish-status="success" simple>
                    <el-step title="卡片信息"></el-step>
                </el-steps> -->
                <el-form ref="AddStockInForm1" v-bind:model="FormStep1" v-bind:rules="rules1">
                    <div class="block-card ">
                        <div class="form-block">
                            <div class="row-step">
                                <span>{{ $t('vault.CardHobbyVault') }}<em>*</em></span>
                            </div>
                            <div class="custom-box">
                                <el-form-item prop="ValutId">
                                    <el-select class="vault-select" v-bind:disabled="['view'].includes(showType)" style="width:100%" v-model="FormStep1.ValutId" :placeholder="$t('vault.CardHobbyVault')">
                                        <el-option v-for="(item, index) in vaultList" :key="index" :label="item.EnValutName" :value="item._id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>


                        <div class="form-block">
                            <div class="row-step">
                                <span>
                                    {{ $t('vault.CardInformation') }}
                                    <el-image class="info-icon" style="width:18px;height:18px;top:3px;" src="/static/images/icon/info.png" fit="contain" v-bind:preview-src-list="['/static/images/vault/ratingCardInfo.png']" v-bind:initial-index="0">
                                    </el-image>
                                    <em>*</em>
                                </span>
                                <span class="row-tips">{{ $t('vault.Maximumcards', { n: maxCardCount }) }}</span>
                            </div>
                            <div class="card-row">
                                <el-form-item prop="Details" v-bind:rules="formRule(1, 'Details', '卡片信息')">
                                    <div class="rating-block" v-for="(obj, key) in cardDetails" v-bind:key="key">
                                        <div class="rating-info">
                                            <!-- <span :class="['card-numb', cardHaveRepeated.includes(key) ? 'iffy' : '']">{{ key + 1 }}.</span> -->
                                            <el-select class="r-info-label" v-model="obj.ProfessionalGrader" :placeholder="$t('vault.GradingCompany')">
                                                <el-option v-for="(item, index) in ratingOptions" :key="index" :label="item.label" :value="item.value">
                                                </el-option>
                                            </el-select>
                                            <!-- <el-input-number  class="r-info-label form-input" style="text-align: left;" :min="0" v-model="obj.CertificationNumber"  :placeholder="$t('vault.CertificationNumber')" :controls="false"></el-input-number> -->
                                            <el-input class="r-info-label form-input" type="number" :min="0" v-model="obj.CertificationNumber" :placeholder="$t('vault.CertificationNumber')"></el-input>
                                        </div>
                                        <div class="add-rating ">
                                            <el-button class="add-r-btn" :disabled="cardDetails.length <= 1" v-on:click="delRating(obj, key)">{{ $t('base.delete') }}</el-button>
                                            <el-button class="add-r-btn" :disabled="cardDetails.length >= maxCardCount" v-on:click="addRating()">{{ $t('base.add') }}</el-button>
                                        </div>
                                    </div>
                                </el-form-item>
                                <!-- @*<div class="tips-row tips-yellow" style="margin-bottom:0" v-if="cardDetails.length >= maxCardCount">卡片最多可添加 {{ maxCardCount }}张</div>*@ -->
                                <div class="tips-row tips-red" style="margin-bottom:0" v-if="cardHaveRepeated.length > 0">{{ $t('vault.Duplicatecarddetected') }}</div>
                            </div>
                        </div>

                        <!-- @* #region 图集 *@ -->
                        <div class="form-block">
                            <div class="row-step">
                                <span>{{ $t('vault.UploadCardPhotos') }}<em>*</em></span>
                                <span class="row-tips">{{ $t('vault.Maximumphotos', { n: (picListLimit || '/') }) }}</span>
                            </div>
                            <div :class="['custom-box']">
                                <el-form-item prop="Imgs" v-bind:rules="formRule(1, 'Imgs', '')">
                                    <upload-images ref="UploadImages" @returnImgs="setPicList" :parentPicList="parentPicList" :picListLimit="picListLimit" :border="true" :needReturn="true"></upload-images>
                                </el-form-item>
                            </div>
                        </div>
                        <!-- @* #endregion 图集 *@ -->

                        <!-- @*<div class="form-block">
                        <div class="row-step">备注</div>
                        <div class="custom-box">
                            <el-form-item>
                                <el-input type="textarea" class="form-input" v-model="FormStep1['Remark']" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="200" show-word-limit>
                                </el-input>
                            </el-form-item>
                        </div>
                    </div>*@ -->
                    </div>
                </el-form>
                <!-- @*第二部 填写退回地址*@ -->
                <!-- <el-steps :active="step2" finish-status="success" simple>
                    <el-step title="退件地址"></el-step>
                </el-steps> -->

                <div class="address_title">
                    <h3>{{ $t('vault.ReturnShippingAddress') }}<span class="text_blue" @click="showMyAddress">{{ $t('vault.SelectAddress') }}</span></h3>
                </div>


                <el-form ref="AddStockInForm2" v-bind:model="FormStep2" v-bind:rules="rules2">
                    <el-form-item prop="Contacts">
                        <el-input type="hidden" class="form-input" v-model="FormStep2['Contacts']" placeholder=""></el-input>
                        <!-- <el-button v-on:click="showMyAddress">选择地址</el-button> -->
                    </el-form-item>
                    <div class="block-card">

                        <ul class="address_list" v-if="FormStep2.Contacts && FormStep2.Address">
                            <li class="address_checkbox on">
                                <div><span>{{ FormStep2.Contacts }}</span> ({{ MemberSource }})</div>
                                <div>
                                    <span>{{ FormStep2.Province }} {{ FormStep2.Address1 }} {{ FormStep2.Address2 }} </span>
                                </div>
                                <div>{{ FormStep2.Phone }}</div>
                            </li>
                        </ul>

                        <div class="text_blue tips_address">{{ $t("vault.ReturnShippingAddressTips") }}</div>
                        <!-- <div class="address-val block-table" v-if="FormStep2.Contacts && FormStep2.Address">
                            <div class="block-table-row"><span class="table-label">联系人：</span><span>{{ FormStep2.Contacts }}</span></div>
                            <div class="block-table-row"><span class="table-label">电话：</span><span>{{ FormStep2.Phone }}</span></div>
                            <div class="block-table-row"><span class="table-label">地址：</span><span>{{ FormStep2.Province }}<br>{{ FormStep2.Address1 }}<br>{{ FormStep2.Address2 }} </span></div>
                        </div> -->
                        <!-- <div class="addrees-select">
                            <el-form-item prop="Contacts">
                                <el-input type="hidden" class="form-input" v-model="FormStep2['Contacts']" placeholder=""></el-input>
                               
                            </el-form-item>
                        </div> -->

                    </div>
                </el-form>



                <div class="applyfor-btn-box">
                    <div class="applyfor-buttons" style="justify-content: space-between;">
                        <div class="agreement-box">
                            <template v-if="showType != 'edit'">
                                <div class="agreement-label" v-on:click="ifAgreement(vaultAgreementType)">
                                    <div class="agreement-side">
                                        <div v-if="vaultAgreement" class="el-icon-success"></div>
                                        <i v-else class="radio-icon"></i>
                                    </div>
                                    <span>{{ $t('vault.agreeToVault') }}</span>
                                </div>
                                <router-link class="text_blue" :to="{ path:`/terms/privacy?type=${vaultAgreementType}`}" target="_blank">{{ $t('vault.VaultStorageAgreement') }}</router-link>
                            </template>
                        </div>

                        <div>
                            <template v-if="vaultWareId">
                                <router-link class="sfl input_border" :to="{ path: '/vault/StockInMgt/' + vaultWareId }">
                                    <el-button>{{ $t('base.back') }}</el-button>
                                </router-link>
                            </template>
                            <el-button v-if="[0].includes(itemDetail.Status) && showType == 'edit'" size="medium" v-bind:class="['l-it']" type="primary" plain v-on:click="changeToEdit('view')">
                                {{ $t('base.cancel') }}
                            </el-button>
                            <el-button v-if="['add', 'edit'].includes(showType)" size="medium" v-bind:disabled="submitLoading" v-bind:loading="submitLoading" v-bind:class="[submitLoading ? 'submitLoading' : '', 'l-it']" type="primary" v-on:click="FormSubmit">
                                <!-- {{ showType == 'edit' ? '提交' : '提交申请' }} -->
                                {{ $t('base.Submit') }}
                            </el-button>
                        </div>
                    </div>
                </div>
                <!-- @*endregion*@ -->

            </div>
            <!-- @* #endregion *@ -->


            <!-- @* #region 查看详情 *@ -->
            <template v-if="showType == 'view'">
                <div :class="['apply-form-box']" v-if="itemDetail._id">
                    <!-- @*卡片信息*@ -->
                    <!-- <el-steps v-if="0" active="1" finish-status="success" simple>
                        <el-step title="卡片信息"></el-step>
                    </el-steps> -->
                    <div class="stockInApplyVaultBox">
                        <div class="block-card ">
                            <div class="form-block ApplyVaultBox">
                                <div class="dtl-cont">
                                    <div :class="['vStatus', 'vStatus-' + itemDetail.Status]">
                                        <!-- {{ itemDetail.StatusMsg }} -->
                                        {{ orderStatusSet(itemDetail.Status) }}
                                        <!-- @*{{ itemDetail.Status }}*@ -->
                                    </div>
                                </div>
                                <div class="text_gray" style="line-height: 1.3;text-align: right;">
                                    <div class="">
                                        <span>{{ $t('vault.SubmissionID') }}:</span>{{ itemDetail.Code }}
                                    </div>
                                    <div class="">
                                        <div class=""><span>{{ $t('base.createTime') }}:</span>{{ setTime(itemDetail.CreateDate) }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="block-card">
                            <div class="form-block">
                                <div class="detail-block-title">
                                    <span>{{ itemDetail.ValutEnName }}</span>
                                </div>
                                <template v-if="itemDetail.VaultConsigneeAddress">
                                    <!-- @*<div class="dtl-row flex">
                                    <div class="dtl-label"><span>{{ itemDetail.ValutName }}</span></div>
                                    <div class="dtl-cont"></div>
                                </div>*@ -->
                                    <div class="dtl-row flex">
                                        <div class="dtl-label">
                                            {{ itemDetail.VaultConsigneeAddress.Address }}  {{ itemDetail.VaultConsigneeAddress.District }} {{ itemDetail.VaultConsigneeAddress.City }} {{ itemDetail.VaultConsigneeAddress.Province }} {{ itemDetail.VaultConsigneeAddress.ZipCode }}
                                        </div>
                                        <div class="dtl-cont"></div>
                                    </div>
                                    <div class="dtl-row flex">
                                        <div class="dtl-label"><span>{{ itemDetail.VaultConsigneeAddress.Contacts }}</span>{{ itemDetail.VaultConsigneeAddress.Phone }}</div>
                                        <div class="dtl-cont"></div>
                                    </div>
                                </template>

                                <div class="block-subtitle text_gray">{{ $t('vault.notAcceptPay') }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="block-card">
                        <div class="form-block">
                            <div class="detail-block-title"><span>{{ $t('vault.CompanyandNumber') }} ({{ itemDetail.Details.length }})</span></div>
                            <div class="dtl-row">
                                <!-- @*<div class="dtl-label"></div>*@ -->
                                <div class="dtl-cont fill">
                                    <el-table :data="itemDetail.Details" style="width: 100%">
                                        <el-table-column :label="$t('base.items')" width="180">
                                            <template slot-scope="scope">
                                                <span class="dtl-card-grader">{{ scope.row.ProfessionalGrader }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column :label="$t('vault.CertificationNumber')">
                                            <template slot-scope="scope">
                                                <span>{{ scope.row.CertificationNumber }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column :label="$t('base.status')" width="180">
                                            <template slot-scope="scope">
                                                <span :class="['card-status', 'card-status-' + scope.row.Status]">{{ cardStatusSet(scope.row.Status) }}</span>
                                            </template>
                                        </el-table-column>
                                        <!-- @*<el-table-column label="是否退回" width="80" v-if="itemDetail.Status == 3 && checkReturnCard(itemDetail.Details)">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.ReturnInfoId">是</span>
                                        </template>
                                    </el-table-column>*@ -->
                                    </el-table>
                                    <!-- <div v-if="checkReturnCard(itemDetail) || [5, 6].includes(itemDetail.Status)" class="btn-view-info" v-on:click="checkReturnInfo">
                                        查看问题
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- @* #region 图集 *@ -->
                    <div class="block-card">
                        <div class="detail-block-title"><span>{{ $t('vault.CardPhotos') }}</span></div>
                        <div class="form-block">
                            <div class="dtl-row">
                                <div class="dtl-cont">
                                    <div class="dtl-card-img" v-for="(img, k) in itemDetail.Imgs" :key="k">
                                        <el-image class="dtl-img" :src="img" fit="contain" :preview-src-list="itemDetail.Imgs" :initial-index="currentPreviewIndex" v-on:click="handlePreview(k, itemDetail.Imgs)">
                                        </el-image>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- @* #endregion 图集 *@ -->
                    <div class="block-card TrackingBox" v-if="itemDetail.Status > 0">
                        <div class="detail-block-title"><span>{{ $t('base.trackingDetails') }}</span></div>
                        <!-- @*<div class="detail-block-title">发货单</div>*@ -->
                        <!-- <div class="edit-partial" v-if="[0, 1].includes(itemDetail.Status) && itemDetail.ReturnInfos.length > 0" v-on:click="showShipDialog(itemDetail)">
                            {{ itemDetail.TrackingNumber ? '修改' : '寄出' }}
                        </div> -->
                        <div v-if="itemDetail.ReturnInfos.length > 1" class="ReturnAddress">
                            <span v-for="(item, index) in itemDetail.ReturnInfos" :key="index" :class="{ 'active': (vaultItemAddress.Id == item.Id) }" @click="vaultItemAddress = item">{{ item.Contacts }}</span>
                        </div>
                        <div class="TrackingCourier">
                            <div v-if="vaultItemAddress && itemDetail.ReturnCard && itemDetail.ReturnCard[vaultItemAddress.Id]">
                                <span class="text_gray">{{ $t('vault.ReturnCards') }}:</span> <span v-for="(card, kk) in itemDetail.ReturnCard[vaultItemAddress.Id]" v-bind:key="kk"><span>{{ card.ProfessionalGrader }}</span> <span>{{ card.CertificationNumber }}</span></span>
                            </div>
                            <template v-if="[1, 2, 3].includes(itemDetail.Status)">
                                <div>
                                    <span class="text_gray">{{ $t('base.carrierName') }}:</span>{{ itemDetail.LogisticsCompany }}
                                </div>
                                <div>
                                    <span class="text_gray">{{ $t('base.trackingNumber') }}:</span>{{ itemDetail.TrackingNumber }}
                                </div>
                            </template>
                            <template v-if="[5, 6].includes(itemDetail.Status) && vaultItemAddress.LogisticsCompany">
                                <div>
                                    <span class="text_gray">{{ $t('base.carrierName') }}:</span>{{ vaultItemAddress.LogisticsCompany }}
                                </div>
                                <div>
                                    <span class="text_gray">{{ $t('base.trackingNumber') }}:</span>{{ vaultItemAddress.TrackingNumber }}
                                </div>
                            </template>
                            <template v-if="[5, 6].includes(itemDetail.Status) && !vaultItemAddress.LogisticsCompany">
                                <div>
                                    <span class="text_gray">物流状态:</span>待退回
                                </div>
                            </template>
                        </div>
                        <template v-if="[1, 2, 3].includes(itemDetail.Status) || vaultItemAddress.LogisticsCompany">
                            <div class="TrackingLog">
                                <template v-if="expressDetail.TrackList">
                                    <div :class="{ 'steps_up': stepsUp}">
                                        <div class="steps_list"   v-for="(item, index) in expressDetail.TrackList" :key="index">
                                            <div class="steps_list_up">
                                            <span class="time">{{setTime(item.TrackDate)}}</span>
                                            <span class="dott"></span>
                                            <span class="add">{{item.TrackStatus}}</span>
                                            </div>
                                            <div class="steps_line"></div>
                                        </div>
                                    </div>
                                    <div style="text-align: center;cursor: pointer;" @click="stepsUp = !stepsUp">{{stepsUp ? $t('base.ShowMore') : $t('base.Collapse')}}</div>
                                </template>
                                <!-- </template>
                                <template v-if="expressDetail.TrackList">
                                    <el-timeline>
                                        <el-timeline-item v-for="(item, index) in expressDetail.TrackList" :key="index" :timestamp="item.TrackDate">
                                            {{ item.TrackStatus }}
                                        </el-timeline-item>
                                    </el-timeline>
                                </template> -->
                                <div v-else>{{ $t('base.NoLogistics') }}</div>
                            </div>
                        </template>
                    </div>

                    <div class="block-card">
                        <div class="detail-block-title"><span>{{ $t('vault.ReturnAddress') }}</span></div>
                        <ul class="address_list">
                            <li class="address_checkbox">
                                <div><span>{{ vaultItemAddress.Contacts }}</span></div>
                                <div>
                                    <span>{{ vaultItemAddress.Province }}-{{ vaultItemAddress.Address }}</span>

                                </div>
                                <div>{{ vaultItemAddress.Phone }}</div>
                                <span class="change text_blue chage_address" v-if="[0, 1, 2].includes(itemDetail.Status)" v-on:click="showMyAddress('edit', vaultItemAddress.Id)">{{ $t('base.edit') }}</span>
                            </li>
                        </ul>
                        <div class="text_blue tips_address" v-if="[0, 1, 2].includes(itemDetail.Status)">{{ $t("vault.ReturnShippingAddressTips") }}</div>
                    </div>

                    <!-- @*退回地址*@ -->
                    <!-- <el-steps :active="itemDetail.ReturnInfos.length > 0 ? 1 : 0" finish-status="success" simple>
                        <el-step :title="[5, 6].includes(itemDetail.Status) ? '退回地址' : '退回地址'"></el-step>
                    </el-steps> -->
                    <!-- <div class="block-card">
                    <div class="detail-block-title"><span>{{[5, 6].includes(itemDetail.Status) ? '退回地址' : '退回地址'}}</span></div>

                        <div class="detail-block-last" :class="['detail-block', `detail-block-${k + 1 == itemDetail.ReturnInfos.length ? 'last' : ''}`]" v-for="(obj, k) in itemDetail.ReturnInfos" v-bind:key="k">

                            <div class="edit-partial" v-if="[0, 1, 2].includes(itemDetail.Status)" v-on:click="showMyAddress('edit', obj.Id)">修改</div>
                            <div class="dtl-row">
                                <div class="dtl-label"><span>联系人:</span></div>
                                <div class="dtl-cont">{{ obj.Contacts }}</div>
                            </div>
                            <div class="dtl-row">
                                <div class="dtl-label"><span>电话号:</span></div>
                                <div class="dtl-cont">{{ obj.Phone }}</div>
                            </div>
                            <div class="dtl-row">
                                <div class="dtl-label"><span>退回地址:</span></div>
                                <div class="dtl-cont">
                                    {{ obj.Province }}-{{ obj.Address }}
                                </div>
                            </div>
                            <div class="dtl-row" v-if="[5, 6].includes(itemDetail.Status)">
                                <div class="dtl-label"><span>物流信息:</span></div>
                                <div class="dtl-cont flex-between" style="flex:1">
                                    <template v-if="obj.LogisticsCompanyCode">
                                        {{ obj.LogisticsCompany }}&nbsp;&nbsp;{{ obj.TrackingNumber }}
                                        <div class="express-btn pointer" v-on:click="getExpress(obj)">跟踪物流信息</div>
                                    </template>
                                    <template v-else>
                                        <span class="txt-gray">待退回</span>
                                    </template>
                                </div>
                            </div>
                            <div class="dtl-row" v-if="itemDetail.ReturnCard[obj.Id]">
                                <div class="dtl-label"><span>退回卡片:</span></div>
                                <div class="dtl-cont">
                                    <template v-if="itemDetail.ReturnCard && itemDetail.ReturnCard[obj.Id]">
                                        <div class="dtl-card-ls" v-for="(card, kk) in itemDetail.ReturnCard[obj.Id]" v-bind:key="kk">
                                            <span class="dtl-card-grader">{{ card.ProfessionalGrader }}</span><span>{{ card.CertificationNumber }}</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="dtl-card-ls">无退回卡片</div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="text_blue tips_address"  v-if="[0, 1, 2].includes(itemDetail.Status)">Vault仓检验包裹，若发现商品存在损坏、不符合约定要求的情况，需及时填写有效退货地址，<br />后台将根据填写的地址，将不符合要求的商品统一回寄</div>
                    </div> -->

                    <!-- @*我的发货单号*@ -->
                    <!-- <el-steps :active="itemDetail.TrackingNumber ? 1 : 0" finish-status="success" simple>
                        <el-step title="发货单"></el-step>
                    </el-steps> -->

                    <!-- <div class="block-card TrackingBox">
                        <div class="detail-block-title"><span>发货单</span></div>
                        <div class="edit-partial" v-if="[0, 1].includes(itemDetail.Status) && itemDetail.ReturnInfos.length > 0" v-on:click="showShipDialog(itemDetail)">
                            {{ itemDetail.TrackingNumber ? '修改' : '寄出' }}
                        </div>
                        
                        <div class="detail-block">
                            <div class="dtl-row">
                                <div class="dtl-label"><span>快递公司:</span></div>
                                <div class="dtl-cont">
                                    {{ itemDetail.LogisticsCompany }}
                                </div>
                            </div>
                            <div class="dtl-row">
                                <div class="dtl-label"><span>快递单号:</span></div>
                                <div class="dtl-cont flex-between" style="flex:1">
                                    {{ itemDetail.TrackingNumber }}
                                    <div v-if="itemDetail.LogisticsCompany && itemDetail.TrackingNumber" class="express-btn pointer" v-on:click="getExpress(itemDetail)">跟踪物流信息</div>
                                </div>
                            </div>
                        </div>
                    </div> -->


                    <!-- @*、、、*@ -->

                    <div class="applyfor-btn-box">
                        <div class="applyfor-buttons" style="justify-content: space-between;">
                            <div>
                                <!-- <el-button class="sfl input_border" v-on:click="handleBackList()">
                                返回列表
                            </el-button> -->
                                <router-link v-if="vaultWareId" class="sfl input_border" :to="{ path: '/vault/StockInMgt/' + vaultWareId }">
                                    <el-button>{{ $t('base.back') }}</el-button>
                                </router-link>
                            </div>
                            <div>
                                <!-- <el-button>查看问题</el-button> -->
                                <el-button v-if="[0].includes(itemDetail.Status) && showType == 'view'" class="l-it" size="medium" v-on:click="changeToEdit('edit')">
                                    {{ $t('base.edit') }}
                                </el-button>
                                <!-- 寄往vault -->
                                <el-button v-if="[0, 1].includes(itemDetail.Status) && itemDetail.ReturnInfos.length > 0" v-on:click="showShipDialog(itemDetail)" type="primary">{{ itemDetail.TrackingNumber ? $t('vault.EditShipment') : $t('vault.Ship') }}</el-button>
                                <el-button v-if="checkReturnCard(itemDetail) || [5, 6].includes(itemDetail.Status)" type="danger" v-on:click="checkReturnInfo">{{ $t('vault.viewIssues') }}</el-button>
                                <el-button v-if="[5, 6].includes(itemDetail.Status)" v-on:click="gotoContact" type="primary">{{ $t('alert.contactUs') }}</el-button>
                            </div>
                        </div>
                    </div>
                    <!-- @*endregion*@ -->

                </div>
                <div v-else>
                    <div v-if="loading" class="ls-loading">
                        Loading...
                    </div>
                    <div v-else class="no-data">
                        <div>No Data</div>
                    </div>
                </div>
            </template>
            <!-- @* #endregion查看详情 *@ -->

            <!-- @* #region 查看问题 *@ -->
            <div v-if="dialogCheckCardInfoVisible">
                <el-dialog :title="$t('vault.IdentifiedIssues')" :visible.sync="dialogCheckCardInfoVisible" width="800px" top="15vh" :before-close="handleCheckCardInfoClose" :close-on-click-modal="false" :close-on-press-escape="false">
                    <div class="dialog-address-box">
                        <div class="check-card-info">
                            <div class="tips-row tips-red">
                                {{ itemDetail.VerifyRemark ? itemDetail.VerifyRemark : $t('vault.CardIssues') }}
                                <template v-if="(itemDetail.VerifyImg && itemDetail.VerifyImg.length) || (itemDetail.VerifyVideo && itemDetail.VerifyVideo.length) ">
                                    <div>{{$t('vault.findingsbelow')}}:</div>
                                </template>
                            </div>
                            <div class="dtl-cont check-card-block">
                                <div class="dtl-card-img dtl-card-img-big check-card-row" v-for="(obj, k) in itemDetail.VerifyImg" v-bind:key="`img${k}`">
                                    <el-image class="dtl-img" :src="obj + '?imageView2/2/h/150'" fit="contain" :preview-src-list="itemDetail.VerifyImg">
                                    </el-image>
                                </div>
                                <div class="dtl-card-img dtl-card-video check-card-row" v-for="(obj, k) in itemDetail.VerifyVideo" v-bind:key="`video${k}`">
                                    <video style="width:100%;height:100%" controls :src="obj">
                                        Your browser does not support the video tag
                                    </video>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="applyfor-btn-box">
                            <div class="applyfor-buttons" style="justify-content: space-between;">
                                <div>
                                    <el-button class="sfl input_border" v-on:click="handleCheckCardInfoClose()">
                                        关闭
                                    </el-button>
                                </div>
                                <div>
                                    <a href="#">联系客服</a>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </el-dialog>
            </div>
            <!-- @* #endregion *@ -->

            <!-- @* #region 地址列表 *@ -->
            <div v-if="dialogAddressVisible">
                <el-dialog :title="$t('vault.SelectAddress')" :visible.sync="dialogAddressVisible" width="800px" top="15vh" :before-close="handleAddressClose" :close-on-click-modal="false" :close-on-press-escape="false">
                    <div class="dialog-address-box">
                        <ul class="address_list" v-if="!addrLoading">
                            <li class="address_checkbox" :class="{ 'on': (currentRowKey == item.Id) }" v-for="(item, index) in addressList" :key="index" @click="handleRowClick(item)">
                                <div><span>{{ item.UserName }}</span> ({{ item.Country }})</div>
                                <div>
                                    <span>{{ item.StreetAddress != null ? item.StreetAddress + ', ' : '' }}</span>
                                    <span v-if="item.StreetAddress2 != null && item.StreetAddress2 != ''">{{ item.StreetAddress2 != null && item.StreetAddress2 != '' ? item.StreetAddress2 + ', ' : '' }}</span>
                                    <span>{{ item.City != null ? item.City + ', ' : '' }}</span>
                                    <span>{{ item.StateCode != null ? item.StateCode + ', ' : '' }}</span>
                                    <span>{{ item.ZipCode }}</span>
                                </div>
                                <div>{{ item.Phone }}</div>
                            </li>
                        </ul>
                        <!-- <el-table :data="addressList" highlight-current-row :current-row-key="currentRowKey" v-on:row-click="handleRowClick" row-class-name="address-row" v-bind:loading="addrLoading" style="width: 100%" height="500">
                            <el-table-column label="姓名">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.UserName }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="电话">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.Phone }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="城市">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.Country }} {{ scope.row.StateCode }} {{ scope.row.City }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="地址">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.StreetAddress }}<br>{{ scope.row.StreetAddress2 }}</span>
                                </template>
                            </el-table-column>
                        </el-table> -->
                        <div :class="[addrType == 'edit' ? 'flex-end' : 'flex-center']" style="padding:10px;">
                            <el-button type="primary" plain v-on:click="addNewAddress">{{ $t('base.addNewAddress') }}</el-button>

                            <el-button type="primary" v-if="addrType == 'edit'" v-on:click="editAddress()" v-bind:disabled="!currentRowData.Contacts">{{ $t('base.confirm') }}</el-button>
                        </div>
                    </div>
                </el-dialog>
            </div>
            <!-- @* #endregion *@ -->

            <!-- @* #region 物流信息轨迹 *@ -->
            <el-dialog v-if="isExpress" title="物流信息" :visible.sync="isExpress">
                <div style="padding:20px 50px 50px;max-height:500px;overflow:auto">
                    <div v-if="expressLoading"> Loading...</div>
                    <div v-else>
                        <div style="margin-bottom: 20px;">{{ expressDetail.LogisticsCompany }}：{{ expressDetail.TrackingNumber }}</div>
                        <template v-if="expressDetail.TrackList">
                            <el-timeline>
                                <el-timeline-item v-for="(item, index) in expressDetail.TrackList" :key="index" :timestamp="item.TrackDate">
                                    {{ item.TrackStatus }}
                                </el-timeline-item>
                            </el-timeline>
                        </template>
                        <div v-else>{{ $t('base.NoLogistics') }}</div>
                    </div>
                </div>
            </el-dialog>
            <!-- @* #endregion *@ -->

            <!-- @* #region 发货 *@ -->
            <div v-if="dialogShipVisible">
                <el-dialog :title="$t('vault.Ship')" :visible.sync="dialogShipVisible" width="520px" top="10vh" :before-close="handleShipClose" :close-on-click-modal="false" :close-on-press-escape="false">
                    <div class="dialog-form-box">
                        <!-- @* 发货 Form *@ -->
                        <el-form ref="ShipFormRef" v-bind:model="ShipForm" v-bind:rules="rulesShip">
                            <div class="block-card border-none">
                                <div class="form-block">
                                    <div class="row-step">
                                        <span>{{ $t('base.carrierName') }}<em>*</em></span>
                                    </div>
                                    <div class="custom-box">
                                        <el-form-item prop="shipFormSelVal">
                                            <el-select class="vault-select" style="width:100%" v-model="shipFormSelVal" value-key="ShipperName" name="LogisticsCompany" filterable data-live-search="true" :placeholder="$t('vault.SelectCarrier')" v-on:change="handleChangeExp($event)">
                                                <el-option v-for="(item, index) in expressList" v-bind:key="index" v-bind:label="item.ShipperName" v-bind:value="item">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </div>

                                <div class="form-block">
                                    <div class="row-step">
                                        <span>{{ $t('base.trackingNumber') }}<em>*</em></span>
                                    </div>
                                    <div class="custom-box">
                                        <el-form-item prop="TrackingNumber">
                                            <el-input type="text" class="form-input" v-model="ShipForm['TrackingNumber']" placeholder=""></el-input>
                                        </el-form-item>
                                    </div>
                                </div>

                                <template v-if="itemDetail.VaultConsigneeAddress">
                                    <div class="form-block">
                                        <div class="detail-block-title">
                                            <span>{{ itemDetail.ValutEnName }}</span>
                                            <div class="block-subtitle">{{ $t('vault.notAcceptPay') }}</div>
                                        </div>
                                        <div class="dtl-row flex">
                                            <div class="dtl-label">{{ itemDetail.VaultConsigneeAddress.Province }} {{ itemDetail.VaultConsigneeAddress.City }} {{ itemDetail.VaultConsigneeAddress.District }} {{ itemDetail.VaultConsigneeAddress.Address }}</div>
                                            <div class="dtl-cont"></div>
                                        </div>
                                        <div class="dtl-row flex">
                                            <div class="dtl-label"><span>{{ itemDetail.VaultConsigneeAddress.Contacts }}</span> {{ itemDetail.VaultConsigneeAddress.Phone }}</div>
                                            <div class="dtl-cont"></div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div class="applyfor-btn-box">
                                <div class="applyfor-buttons" style="justify-content: space-between;">
                                    <div>
                                        <el-button class="sfl input_border" v-on:click="handleShipClose()">
                                            {{ $t('base.cancel') }}
                                        </el-button>

                                        <!-- <el-button type="primary" v-on:click="ShipSubmit('test')">
                                        测试提交
                                    </el-button> -->
                                    </div>
                                    <div>
                                        <el-button :disabled="submitLoading" v-bind:class="[submitLoading ? 'submitLoading' : '', 'l-it']" type="primary" v-on:click="ShipSubmit">
                                            {{ $t('base.Submit') }}
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-form>

                    </div>
                </el-dialog>
            </div>
            <!-- @* #endregion *@ -->
        </div>
    </div>
</template>

<script>
import VaultStockInMgt from './js/vue-VaultStockInApply.js';

export default {
    ...VaultStockInMgt
};
</script>


<style scoped>
@import "../../../static/css/usertabslist.css";
@import "../../../static/css/vault/stockInMgt.css";
/deep/ input[type=number]::-webkit-outer-spin-button,
/deep/ input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* 隐藏 Firefox 的上下箭头 */
/deep/ input[type=number] {
    -moz-appearance: textfield;
}
</style>


// WEBPACK FOOTER //
// src/pages/Vault/StockInApply.vue